// Contextual next-step copy toward /concierge (the deal-review funnel. THE
// money path). Every content dead-end should close with one of these instead
// of a generic button. Keyed by myth-card category; first matching category
// wins, in the order given here.
//
// Model note: the site educates for free, then graduates ready buyers to a
// free deal review; we read the quote and say what's wrong with it. These
// used to promise a dealer introduction; we have no dealers, so they don't
// anymore (2026-08-09). Don't reintroduce dealer language here until there
// is an actual dealer on the other end of it.

const CATEGORY_CTA = [
  {
    categories: ['Cost', 'Subsidies'],
    text: "The sticker price isn't where they get you, the junk fees and phantom credits are. Send us the out-the-door sheet and we'll show you which lines to refuse. Free.",
    label: 'Check my quote',
  },
  {
    categories: ['Charging', 'Range', 'Cold weather'],
    text: "The fix for range worry is the right EV for how YOU drive. We'll match you in 30 seconds, then read your deal before you sign it. Free.",
    label: 'Find my EV, free',
  },
  {
    categories: ['Battery life', 'Reliability', 'Safety', 'EV fires'],
    text: "Most EV horror stories trace to a dealer who never sold one. Send us what they quoted you and we'll tell you what they're pulling. Free.",
    label: 'Have my deal reviewed',
  },
  {
    categories: ['EV sales', 'Tesla', 'Politics & Policy'],
    text: "Ignore the noise: millions of people just quietly bought EVs. When you're ready to be one of them, we'll read your deal before you sign it. Free.",
    label: 'Get help buying',
  },
];

const DEFAULT_CTA = {
  text: "Convinced (or at least curious)? We'll match you to the right EV and read your deal before you sign it, free.",
  label: 'Get help buying, free',
};

export function cardFunnelCopy(categories = []) {
  for (const entry of CATEGORY_CTA) {
    if (entry.categories.some((c) => categories.includes(c))) {
      return { text: entry.text, label: entry.label };
    }
  }
  return DEFAULT_CTA;
}

// Top-of-page deal-review nudge (2026-10-28). Search visitors land on the
// programmatic templates, not the homepage, and on those the deal-review ask
// sat at the very bottom (or behind the 7-question concierge quiz), so almost
// nobody saw it. This is the one-line ask shown right under the page's answer,
// tied to the page's car or city. The button jumps to the deal-review form on
// the same page; it does not navigate away.
export function vehicleNudgeCopy(ev) {
  if (ev.status === 'coming_soon') {
    return {
      title: `Waiting on the ${ev.model}?`,
      text: "We'll tell you when it lands, and when a dealer quotes you on it, send us the sheet and we'll tell you what's wrong with it. Free.",
      label: 'Notify me',
    };
  }
  return {
    title: `Shopping for a ${ev.model}?`,
    text: "Send us the dealer's out-the-door sheet and a real person tells you what's wrong with it, the junk fees, the phantom credits, the add-ons. Free.",
    label: 'Have my deal reviewed',
  };
}

export function cityNudgeCopy(cityName) {
  return {
    title: `Buying an EV in ${cityName}?`,
    text: "The math above only works if the price does. Send us the dealer's out-the-door sheet and a real person tells you what's wrong with it. Free.",
    label: 'Have my deal reviewed',
  };
}

export function stateNudgeCopy(stateName) {
  return {
    title: `Buying an EV in ${stateName}?`,
    text: "Rebates only help if the price is honest. Send us the dealer's out-the-door sheet and a real person tells you what's wrong with it, the junk fees, the phantom credits, the add-ons. Free.",
    label: 'Have my deal reviewed',
  };
}

export function compareNudgeCopy(nameA, nameB) {
  return {
    title: `Deciding between the ${nameA} and the ${nameB}?`,
    text: "Whichever one you land on, send us the dealer's out-the-door sheet and a real person tells you what's wrong with it, the junk fees, the phantom credits, the add-ons. Free.",
    label: 'Have my deal reviewed',
  };
}
